import React from "react";
import { Helmet } from "react-helmet";

interface IHelmetTitleProps {
  title: string;
}

const HelmetTitle = ({ title }: IHelmetTitleProps) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default HelmetTitle;
